/* A static customer preview, never a laser production file. */
(function () {
  'use strict';
  function imageFor(src) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      var timer = window.setTimeout(function () { image.src = ''; reject(new Error('Vorschaubild konnte nicht geladen werden.')); }, 12000);
      image.crossOrigin = 'anonymous';
      image.onload = function () { window.clearTimeout(timer); resolve(image); };
      image.onerror = function () { window.clearTimeout(timer); reject(new Error('Vorschaubild konnte nicht geladen werden.')); };
      image.src = src;
    });
  }
  function geometry(area, zoom, side) {
    var size = side * zoom;
    return { size: size, offset: (side - size) / 2,
      x: (side - size) / 2 + size * (area.centerXPercent - area.widthPercent / 2) / 100,
      y: (side - size) / 2 + size * (area.centerYPercent - area.heightPercent / 2) / 100,
      width: size * area.widthPercent / 100, height: size * area.heightPercent / 100 };
  }
  async function render(snapshot) {
    var images = await Promise.all([imageFor(snapshot.photo), imageFor(snapshot.metal), imageFor(snapshot.mask)]);
    var side = 1000, box = geometry(snapshot.area, snapshot.stageZoom, side);
    if (![box.x, box.y, box.width, box.height].every(Number.isFinite) || box.width <= 0 || box.height <= 0) throw new Error('Ungueltige Vorschauflaeche.');
    var canvas = document.createElement('canvas'); canvas.width = canvas.height = side;
    var ctx = canvas.getContext('2d');
    var photo = images[0], cover = Math.max(box.size / photo.naturalWidth, box.size / photo.naturalHeight);
    ctx.drawImage(photo, (side - photo.naturalWidth * cover) / 2, (side - photo.naturalHeight * cover) / 2, photo.naturalWidth * cover, photo.naturalHeight * cover);
    var layer = document.createElement('canvas'); layer.width = Math.round(box.width); layer.height = Math.round(box.height);
    var lc = layer.getContext('2d'), mask = snapshot.maskBox;
    lc.drawImage(images[2], mask.x * layer.width, mask.y * layer.height, mask.width * layer.width, mask.height * layer.height);
    lc.globalCompositeOperation = 'source-in';
    var metal = images[1], mw = layer.width * snapshot.textureWidthFactor, mh = mw * metal.naturalHeight / metal.naturalWidth;
    var brightness = snapshot.materialBrightness === undefined ? 1 : snapshot.materialBrightness;
    if (!Number.isFinite(brightness) || brightness <= 0 || brightness > 1) throw new Error('Ungueltiger Materialkontrast.');
    if (snapshot.textureSource) {
      var source = snapshot.textureSource;
      if (![source.x, source.y, source.width, source.height].every(Number.isFinite) ||
          source.x < 0 || source.y < 0 || source.width <= 0 || source.height <= 0 ||
          source.x + source.width > 1 || source.y + source.height > 1) throw new Error('Ungueltiger Metall-Ausschnitt.');
      lc.drawImage(metal, source.x * metal.naturalWidth, source.y * metal.naturalHeight,
        source.width * metal.naturalWidth, source.height * metal.naturalHeight, 0, 0, layer.width, layer.height);
    } else {
      lc.drawImage(metal, (layer.width - mw) / 2, (layer.height - mh) / 2, mw, mh);
    }
    if (brightness < 1) {
      // Source-atop retains transparent mask holes; a full overlay must not fill them.
      lc.globalCompositeOperation = 'source-atop';
      lc.fillStyle = 'rgba(0,0,0,' + (1 - brightness) + ')';
      lc.fillRect(0, 0, layer.width, layer.height);
    }
    ctx.save();
    ctx.beginPath();
    ctx.roundRect(box.x, box.y, box.width, box.height, [{ x: box.width * snapshot.area.borderRadiusPercent / 100, y: box.height * snapshot.area.borderRadiusPercent / 100 }]);
    ctx.clip(); ctx.globalAlpha = snapshot.opacity;
    ctx.drawImage(layer, box.x, box.y, box.width, box.height); ctx.restore();
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob || blob.type !== 'image/png' || blob.size > 4 * 1024 * 1024) reject(new Error('Das Vorschaubild konnte nicht erstellt werden.'));
        else resolve(blob);
      }, 'image/png');
    });
  }
  window.__gravurCartMockup = { render: render, geometry: geometry };
})();
